// Replaces zod's `locales` namespace (see zod-slim-plugin.js) with just English, which zod
// installs as its default error map regardless. Nothing in the app translates zod's messages.
module.exports = {
  // zod is a dependency of holocron, not of this app: resolved from the hoisted copy holocron uses
  en: require('zod/v4/locales/en.cjs'), // eslint-disable-line import/no-unresolved, import/no-extraneous-dependencies
};
